const EventDiscountTypeEnum = {
  /** 금액 할인 */
  AMOUNT: '0',
  /** 비율 할인 */
  RATE: '1',
};

export default EventDiscountTypeEnum;
